export const mockServices = [
  {
    title: 'Delphi',
    slug: 'delphi',
    short_description: 'Gestione carriere studenti',
    complete_description:
      "Delphi è il sistema di gestione delle carriere degli studenti dell'Università di Roma Tor Vergata. Consente agli studenti di immatricolarsi, iscriversi agli esami, visualizzare i risultati e gestire le carriere accademiche. Include funzionalità per monitorare il progresso accademico, verificare crediti acquisiti e voti ottenuti.",
    category: 'studenti',
    url: 'https://delphi.uniroma2.it/totem/jsp/index.jsp',
    url_video: '',
    contacts: 'totem-support@uniroma2.it',
  },
  {
    title: 'Microsoft Teams',
    slug: 'microsoft-teams',
    short_description: 'Collaborazione, meeting e chat',
    complete_description:
      "Microsoft Teams è uno strumento di collaborazione offerto da Microsoft, utilizzato che permette di gestire meeting, chat e lavoro di gruppo dell'Università di Roma Tor Vergata. Gli utenti possono creare e partecipare a riunioni online, condividere file e collaborare in tempo reale su documenti. Teams supporta chiamate e videochiamate, con la possibilità di creare team di lavoro per progetti specifici e organizzare canali tematici.",
    category: 'studenti',
    url: 'https://teams.microsoft.com/v2/',
    url_video: 'https://youtu.be/tHZwX7YXH48',
    contacts: 'info@ccd.uniroma2.it',
  },
  {
    title: 'Agenza Web (easy utv)',
    slug: 'agenda-web',
    short_description: 'Gestore di lezioni ed esami',
    complete_description:
      "L'app offre la possibilità di rilevare/segnalare la presenza a lezione, prenotare un posto a lezione o semplicemente visualizzare gli aggiornamenti che verranno effettuati di volta in volta sull'orario.",
    category: 'studenti',
    url: 'https://easyutv.uniroma2.it/agendaweb/',
    url_video: '',
    contacts: 'info@easystaff.it',
  },
  {
    title: 'Gestore spazi (easy utv)',
    slug: 'gestore-spazi',
    short_description: 'Prenotazione di una o più aule',
    complete_description:
      "Applicazione per la gestione delle prenotazioni delle aule, riduce i conflitti e migliora l'efficienza nella gestione degli spazi.",
    category: 'studenti',
    url: 'https://easyutv.uniroma2.it/aule/index.php?_lang=it',
    url_video: '',
    contacts: 'info@easystaff.it',
  },
  {
    title: 'Find UTV (solo rettorato)',
    slug: 'find-utv',
    short_description: 'Naviga nelle strutture del campus',
    complete_description:
      "Benvenuto all'app di navigazione indoor dell'Università Roma 2 Tor Vergata, progettata per semplificare il tuo percorso all'interno dell'ateneo e guidarti in modo efficace verso la destinazione desiderata. Questa app è stata sviluppata appositamente per aiutare gli studenti, i visitatori e il personale a muoversi agevolmente all'interno del complesso universitario di Tor Vergata. Che tu stia cercando un ufficio specifico, un'aula, una sala studio o qualsiasi altra area dell'università, l'app di navigazione indoor è pronta ad assisterti.",
    category: 'studenti',
    url: 'https://linktr.ee/FindUTV',
    url_video: '',
    contacts: 'support@tapmylife.com',
  },
  {
    title: 'CUS',
    slug: 'cus',
    short_description: 'Centro Universitario Sportivo',
    complete_description:
      "Il Centro Universitario Sportivo (CUS) di Tor Vergata offre un'ampia gamma di attività sportive per studenti, dipendenti universitari e cittadini. Con impianti moderni e strutture all'avanguardia, il CUS promuove uno stile di vita sano e attivo, con corsi che spaziano da discipline classiche come il calcio e il basket, fino a sport più innovativi come il padel e l'arrampicata. Il centro è un punto di riferimento non solo per lo sport universitario, ma anche per eventi sportivi e sociali aperti a tutta la comunità locale.",
    category: 'studenti',
    url: 'https://ginnipal.it/CusRomaTorV/AltLogin.aspx',
    url_video: '',
    contacts: 'info@cusromatorvergata.it',
  },
  {
    title: 'Store',
    slug: 'store',
    short_description: 'Prodotti firmati Tor Vergata',
    complete_description:
      "Lo store online dell'Università di Roma Tor Vergata offre una gamma di prodotti con il logo ufficiale dell'Ateneo, come abbigliamento (t-shirt, felpe, cappelli), accessori (zaini, borse), e oggettistica (tazze, borracce, agende). Lo shop permette agli studenti e al pubblico di acquistare articoli brandizzati per mostrare il proprio supporto all'università.",
    category: 'studenti',
    url: 'https://store.uniroma2.it/',
    url_video: '',
    contacts: '',
  },
  {
    title: 'Outlook',
    slug: 'outlook',
    short_description: 'Email istituzionale europea',
    complete_description:
      'Outlook è il servizio di posta elettronica offerto da Microsoft, utilizzato per la gestione della posta istituzionale europea dell’Università di Roma Tor Vergata. Per accedere al servizio, è necessario inserire la propria email europea uniroma2.eu e password associata. Outlook offre diverse funzionalità avanzate come la gestione del calendario, la creazione di eventi, l’invio di inviti a riunioni e la possibilità di condividere documenti. Il servizio supporta i protocolli POP (porta 995, server outlook.office365.com e cifratura SSL/TLS), IMAP (porta 993, server outlook.office365.com e cifratura SSL/TLS) e SMTP (porta 995, server smtp-mail.outlook.com e cifratura STARTTLS) per la gestione della posta.',
    category: 'studenti',
    url: 'https://outlook.office.com/mail/',
    url_video: 'https://youtu.be/w3qyGUHlkz4',
    contacts: 'info@ccd.uniroma2.it',
  },
]
